<template>
  <div
    id="fullscreen"
    style="
      display: flex;
      flex-direction: column;
      gap: 10px;
      background: var(--background-color);
    "
  >
    <div style="display: flex; justify-content: flex-end">
      <vs-button
        radius
        color="success"
        type="border"
        icon="fullscreen"
        @click="openFullscreen"
        v-if="!fullscreen"
      ></vs-button>
      <vs-button
        radius
        color="success"
        type="border"
        icon="fullscreen_exit"
        @click="closeFullscreen"
        v-else
      ></vs-button>
    </div>
    <div class="layout-head" @keydown.esc="esc">
      <div class="m-card">
        <div class="card-frist">
          <img src="@/assets/images/d-net/dhanarak.png" alt="gif" />
          <div>
            <h4 class="text-b" style="color: var(--text-color-2)">
              บริษัท ธนารักษ์พัฒนาสินทรัพย์ จำกัด
            </h4>
            <h5 class="text-b" style="color: var(--text-color-2)">
              Monitoring Temperature and Humidity.
            </h5>
            <div>
              <img src="@/assets/images/pin.png" alt="pin" />
              <address>
                120 อาคารธนพิพัฒน์ ถนน แจ้งวัฒนะ Thung Song Hong, Lak Si,
                Bangkok 10210
              </address>
            </div>
          </div>
        </div>
      </div>
      <div class="m-card">
        <div>
          <h3 style="font-weight: bold">Location</h3>
        </div>
        <l-map style="height: 100px" :zoom="zoom" :center="center">
          <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
          <l-marker
            :lat-lng="marker"
            v-for="(marker, marker_i) in markerLatLng"
            :key="marker_i"
          ></l-marker>
          <!-- <l-polyline
            :lat-lngs="polygon.latlngs"
            :color="polygon.color"
          ></l-polyline> -->
        </l-map>
      </div>
    </div>
    <div class="layout-location">
      <!-- <div class="row m-0" style="gap:10px"> -->

      <div
        style="display: flex; gap: 10px; flex-direction: column"
        v-for="(item, item_i) in locations"
        :key="item_i"
      >
        <room :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
import { LMap, LTileLayer, LPolyline, LMarker } from "vue2-leaflet";
import Room from "./room.vue";

export default {
  components: {
    LMap,
    LTileLayer,
    LPolyline,
    LMarker,
    Room,
  },
  data() {
    return {
      fullscreen: false,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 15,
      center: [13.8833371, 100.5627881],
      markerLatLng: [[13.8823271, 100.5648881]],
      polygon: {
        latlngs: [
          [13.8116717, 100.5650815],
          [13.8109402, 100.565086],
        ],
        color: "green",
      },
      locations: [
        {
          name: "Facility Room",
          location: "thanarak",
          room: "facility",
          img: require("@/assets/images/d-net/Scroll Group 72.png"),
          gateway: [
            {
              x: 63,
              y: 12,
              status: 0,
              mac: "AC233FC0D2B6",
              timestamp: "",
            },
          ],
          sensor: [
            {
              x: 10,
              y: 25,
              temp: 27,
              hum: 50,
              mac: "AC233FAC98A9",
              name: "",
              battery: 0,
              location: "",
              timestamp: "",
            },
            {
              x: 30,
              y: 10,
              temp: 27,
              hum: 50,
              mac: "AC233FAC99AB",
              name: "",
              battery: 0,
              location: "",
              timestamp: "",
            },
            {
              x: 32,
              y: 30,
              temp: 27,
              hum: 50,
              mac: "AC233FAC99AC",
              name: "",
              battery: 0,
              location: "",
              timestamp: "",
            },
            {
              x: 70,
              y: 20,
              temp: 27,
              hum: 50,
              mac: "AC233FAC98B1",
              name: "",
              battery: 0,
              location: "",
              timestamp: "",
            },
            {
              x: 55,
              y: 50,
              temp: 27,
              hum: 50,
              mac: "AC233FAC98AD",
              name: "",
              battery: 0,
              location: "",
              timestamp: "",
            },
            {
              x: 60,
              y: 75,
              temp: 27,
              hum: 50,
              mac: "AC233FAC98AE",
              name: "",
              battery: 0,
              location: "",
              timestamp: "",
            },
          ],
        },
        {
          name: "Data Center Room",
          location: "thanarak",
          room: "data",
          img: require("@/assets/images/d-net/Scroll Group 71.png"),
          gateway: [
            {
              x: 23,
              y: 30,
              status: 0,
              mac: "AC233FC0D3BD",
              timestamp: "",
            },
          ],
          sensor: [
            {
              x: 10,
              y: 30,
              temp: 27,
              hum: 50,
              mac: "AC233FAC98AB",
              name: "",
              battery: 0,
              location: "",
              timestamp: "",
            },
            {
              x: 33,
              y: 10,
              temp: 27,
              hum: 50,
              mac: "AC233FAC98AA",
              name: "",
              battery: 0,
              location: "",
              timestamp: "",
            },
            {
              x: 35,
              y: 50,
              temp: 27,
              hum: 50,
              mac: "AC233FAC98AF",
              name: "",
              battery: 0,
              location: "",
              timestamp: "",
            },
            {
              x: 50,
              y: 30,
              temp: 27,
              hum: 50,
              mac: "AC233FAC98AC",
              name: "",
              battery: 0,
              location: "",
              timestamp: "",
            },
            {
              x: 60,
              y: 80,
              temp: 27,
              hum: 50,
              mac: "AC233FAC98B3",
              name: "",
              battery: 0,
              location: "",
              timestamp: "",
            },
            {
              x: 80,
              y: 60,
              temp: 27,
              hum: 50,
              mac: "AC233FAC98B0",
              name: "",
              battery: 0,
              location: "",
              timestamp: "",
            },
          ],
        },
        
      ],
      timeout: null,
    };
  },
  methods: {
    openFullscreen() {
      let elem = document.querySelector("#fullscreen");
      this.fullscreen = true;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen();
      }
    },
    closeFullscreen() {
      this.fullscreen = false;
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        /* Safari */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE11 */
        document.msExitFullscreen();
      }
    },
    esc() {
      console.log("asd");
      // this.fullscreen =false
    },
    chart() {},
    onRowSelected() {
      console.log("onRowSelected");
    },
    async getGateway() {
      try {
        let res = await this.$API.get("indoorgateway");
        console.log(res);
        for (let i = 0; i < res.data.length; i++) {
          const el = res.data[i];
          for (let j = 0; j < this.locations.length; j++) {
            const element = this.locations[j];
            if (el.mac == element.gateway[0].mac) {
              this.locations[j].gateway[0].status = el.active;
              this.locations[j].gateway[0].timestamp = el.lastdate;
              break;
            }
          }
          this.locations[i];
        }
      } catch (error) {}
    },
    async getSensor() {
      try {
        let res = await this.$API.get("indoorsensor");
        console.log(res);
        for (let i = 0; i < res.data.length; i++) {
          const el = res.data[i];
          for (let j = 0; j < this.locations.length; j++) {
            const jel = this.locations[j];
            for (let k = 0; k < jel.sensor.length; k++) {
              const kel = jel.sensor[k];
              if (el.mac == kel.mac) {
                this.locations[j].sensor[k].temp = el.sensordata.temperature;
                this.locations[j].sensor[k].hum = el.sensordata.humidity;
                this.locations[j].sensor[k].battery = el.sensordata.battery;
                this.locations[j].sensor[k].name = el.name;
                this.locations[j].sensor[k].location = el.location;
                this.locations[j].sensor[k].timestamp = el.lastdate;
                break;
              }
            }
          }
          this.locations[i];
        }
      } catch (error) {}
    },
    async calldata() {
      await this.getGateway();
      await this.getSensor();
      this.timeout = setTimeout(async () => {
        await this.getGateway();
        await this.getSensor();
      }, 30 * 1000);
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  async mounted() {
    this.calldata();
  
  },
};
</script>

<style lang="scss" scoped>
.layout-head {
  display: grid;
  grid: auto/30% auto;
  gap: 10px;
}
.layout-location {
  max-width: 100%;
  display: grid;
  grid: auto/calc(50% - 5px) calc(50% - 5px);
  gap: 10px;
  position: relative;
}
.card-frist {
  display: grid;
  grid: auto/25% 75%;
  align-items: center;
  height: 100%;
  img {
    width: 100%;
  }
  div {
    div {
      display: grid;
      grid: auto/20px auto;
      gap: 5px;
      img {
        width: 100%;
      }
    }
    p {
      color: var(--text-color-2);
    }
  }
}
</style>